import Vue from 'vue';
import moment from 'moment';

export default {

  notifyError(msg) {
    if (typeof (msg) === "object") {
      msg = msg.response.data.msg;
    }
    Vue.notify({
      group: 'app-notification',
      title: '',
      text: msg,
      type: 'error'
    })
  },

  notifyInfo(msg) {
    Vue.notify({
      group: 'app-notification',
      title: '',
      text: msg,
      type: 'info'
    })
  },

  notifySuccess(msg) {
    if (typeof (msg) === "object") {
      msg = msg.data.msg;
    }
    Vue.notify({
      group: 'app-notification',
      title: '',
      text: msg,
      type: 'success'
    })
  },

  getBackendURL() {
    const hostname = window.location.hostname;
    const env = process.env.NODE_ENV || "development";

    if(env == 'production'){
      return 'https://' + hostname + "/api";
    }
    
    return 'http://localhost:5000';
  },

  getURL(fragment) {
    if(fragment[0] != '/') {
      fragment = "/" + fragment;
    }
    return this.getBackendURL() + fragment;
  },

  splitArray(array, chunk_size) {
    var results = [];

    while (array.length) {
      results.push(array.splice(0, chunk_size));
    }

    return results;
  },

  getDateRangePickerOptions() {
    return {
      ranges: {
        Today: [moment(), moment()],
        Yesterday: [
          moment().subtract(1, "days"),
          moment().subtract(1, "days")
        ],
        "Last 7 Days": [moment().subtract(6, "days"), moment()],
        "Last 30 Days": [moment().subtract(29, "days"), moment()],
        "This Month": [moment().startOf("month"), moment().endOf("month")],
        "Last Month": [
          moment()
            .subtract(1, "month")
            .startOf("month"),
          moment()
            .subtract(1, "month")
            .endOf("month")
        ],
        "Last 3 Months": [
          moment()
            .subtract(3, "month")
            .startOf("month"),
          moment()
            .subtract(1, "month")
            .endOf("month")
        ],
        "Last 6 Months": [
          moment()
            .subtract(6, "month")
            .startOf("month"),
          moment()
            .subtract(1, "month")
            .endOf("month")
        ]
      },
      locale: {
        format: "YYYY/MM/DD"
      },
      autoApply: true,
      showDropdowns: true,
      startDate: moment(),
      endDate: moment()
    }
  },

  busy: function (component, showLoadingOverlay = true, componentRefsToDisable = []) {
    if (!showLoadingOverlay) {
      return;
    }

    var loading = component.$loading.show({
      container: component.$refs.rootElement
    });

    for (let i = 0; i < componentRefsToDisable.length; i++) {
      const componentRefToDisable = componentRefsToDisable[i];

      if (component.$refs[componentRefToDisable] == undefined) {
        continue;
      }

      component.$refs[componentRefToDisable].disabled = true;
    }

    return loading;
  },

  unbusy: function (component, overlayRef, showLoadingOverlay = true, componentRefsToDisable = []) {
    if (!showLoadingOverlay) {
      return;
    }

    overlayRef.hide();

    for (let i = 0; i < componentRefsToDisable.length; i++) {
      const componentRefToDisable = componentRefsToDisable[i];

      if (component.$refs[componentRefToDisable] == undefined) {
        continue;
      }

      component.$refs[componentRefToDisable].disabled = false;
    }
  }
};